export default "__VITE_ASSET__b0$$hwqQ__"